import type { PropsWithChildren } from "react";
import { Button } from "react-aria-components";
import { formatIsoDate } from "src/utils/dateTime";
import { tw } from "src/design-system/tw";
import { FormattedDepartureDate } from "../../FormattedDepartureDate/FormattedDepartureDate";

type DateInputProps = PropsWithChildren<{
  mode?: "default" | "popout";
  isOpen: boolean;
  icon: React.ReactNode;
  blink: boolean;
  text?: string;
  date?: Date;
  buttonProps?: React.ComponentProps<typeof Button>;
}>;

export default function DateInput({
  isOpen,
  icon,
  text,
  date,
  buttonProps,
  blink,
  mode = "default",
}: DateInputProps) {
  return (
    <Button
      className={tw(
        "relative flex h-full w-full cursor-pointer items-center gap-2 rounded-md px-2 py-3 text-label-md text-text-secondary hover:bg-neutral-900 focus-visible:outline-1 lg:p-3 lg:text-label-lg",
        mode === "popout" && "bg-neutral-700",
        isOpen && "bg-neutral-900",
        !!date && "text-text-primary",
      )}
      {...buttonProps}
    >
      {icon}
      {date ? (
        <FormattedDepartureDate
          className="mt-0.5"
          dateOptions={{
            day: "2-digit",
            month: "short",
          }}
          departureDate={formatIsoDate(date)}
        />
      ) : (
        <span>{text}</span>
      )}
      {blink && (
        <span className="relative h-2 w-2 rounded-full bg-fill-brand">
          <span className="absolute top-1/2 left-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 rounded-full bg-fill-brand motion-safe:animate-ping"></span>
        </span>
      )}
    </Button>
  );
}
